import { Component, type ReactNode } from "react";

interface State { hasError: boolean }

// Top-level safety net: a startup render error shows a retry screen instead of
// leaving the static index.html fallback on screen forever.
export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("App render error:", error);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-6 text-center text-foreground" role="alert">
        <div>
          <p className="font-display text-3xl text-primary">Proton Health Labs</p>
          <p className="mt-3 text-sm text-muted-foreground">Something went wrong loading the page.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-6 min-h-11 rounded-md bg-primary px-6 font-semibold text-primary-foreground"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
